import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { FILTER_SITES } from "../../constants/filter-types";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { getSites } from "../../services/siteService";
import { WizardSummaryLayout } from '../../components/wizard/wizard-summary-layout';

interface WizardSummaryProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
}

export const WizardSummary: FC<WizardSummaryProps> = ({ onNext = undefined, onBack = undefined }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();
    const [summaryTitle, setSummaryTitle] = useState('');
    const [summaryContent, setSummaryContent] = useState('');

    useEffect(() => {
        const selectedFilterType = values.type;
        generateSummaryTitle(selectedFilterType);
        generateSummaryContent(selectedFilterType);
    }, [values.type, values.settingDatas])

    const generateSummaryTitle = (selectedFilterType: string) => {
        if (selectedFilterType === FILTER_SITES) {
            return setSummaryTitle(translate.byKey(TranslationKeys.sites));
        }
        return setSummaryTitle('')
    }

    const generateSummaryContent = async (selectedFilterType: string) => {
        const selectedFilterOptions = values.settingDatas
        let summaryContent = '';

        if (selectedFilterType === FILTER_SITES) {
            const sites = (await getSites()).rows;
            sites.filter((name) => {
                if (selectedFilterOptions.includes(name.id.toString())) {
                    summaryContent = summaryContent + (name.name) + ", ";
                }
            })
        }
        return setSummaryContent(summaryContent)
    }


    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)} onSubmit={onNext ? (e) => onNext(e) : undefined}>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1">
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.dataFilters)}: <span className="text-sm text-black">{summaryTitle}</span></h4>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.selectedFilters)}: <span className="text-sm text-black">{summaryContent}</span></h4>
            </div>
        </div>
    </WizardSummaryLayout>;
};
